/**
 * This module is a fork of and modifies:
 * https://github.com/necolas/react-native-web
 *
 * The original source is (c) Nicolas Gallagher
 * and licensed under the MIT license found a
 * https://github.com/necolas/react-native-web/blob/master/LICENSE
 */

function flattenArray(array: Array<any>) {
  function flattenDown(array: Array<any>, result: Array<any>) {
    for (let i = 0; i < array.length; i++) {
      const value = array[i]

      if (Array.isArray(value)) {
        flattenDown(value, result)
      } else if (value != null && value !== false) {
        result.push(value)
      }
    }

    return result
  }
  return flattenDown(array, [])
}

export default flattenArray
